import { render, staticRenderFns } from "./SuperAdmin.vue?vue&type=template&id=6827dc35&scoped=true&"
import script from "./SuperAdmin.vue?vue&type=script&lang=js&"
export * from "./SuperAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdmin.vue?vue&type=style&index=0&id=6827dc35&prod&lang=scss&"
import style1 from "./SuperAdmin.vue?vue&type=style&index=1&id=6827dc35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6827dc35",
  null
  
)

export default component.exports